import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

( function( app ) {
  const COMPONENT = {
    init() {
      document.querySelectorAll( '.js-mapbox-map' ).forEach( ( mapEl ) => {
        const token = mapEl.dataset.mapboxToken;
        const style = mapEl.dataset.mapboxStyle;

        let locations = [];
        try {
          locations = JSON.parse( mapEl.dataset.locations || '[]' );
        } catch {
          return;
        }

        if ( !token || !style || !locations.length ) return;
        if ( !mapEl.offsetHeight ) return;

        mapboxgl.accessToken = token;

        const map = new mapboxgl.Map( {
          container: mapEl,
          style,
          center: [locations[0].lng, locations[0].lat],
          zoom: 12,
        } );

        map.scrollZoom.disable();

        const markersById = {};
        const locationEls = document.querySelectorAll( '.js-location-item' );
        let initialBounds = null;

        const clearActive = () => {
          Object.values( markersById ).forEach( ( marker ) => {
            const el = marker.getElement();
            el.classList.remove( 'is-active' );
            el.style.transform = '';
            el.setAttribute( 'aria-pressed', 'false' );
          } );
          locationEls.forEach( ( el ) => {
            el.classList.remove( 'is-active' );
            el.setAttribute( 'aria-pressed', 'false' );
          } );
        };

        const setActive = ( locationId ) => {
          clearActive();
          const marker = markersById[locationId];
          if ( marker ) {
            const el = marker.getElement();
            el.classList.add( 'is-active' );
            el.style.transform = 'scale(1.5)';
            el.setAttribute( 'aria-pressed', 'true' );

            map.flyTo( {
              center: marker.getLngLat(),
              zoom: Math.min( 14, Math.max( map.getZoom(), 13 ) ),
              speed: 0.8,
            } );
          }
          const activeLocation = document.querySelector( `.js-location-item[data-location-id="${locationId}"]` );
          if ( activeLocation ) {
            activeLocation.classList.add( 'is-active' );
            activeLocation.setAttribute( 'aria-pressed', 'true' );
          }
        };

        map.on( 'load', () => {
          map.resize();
          if ( locations.length > 1 ) {
            const bounds = new mapboxgl.LngLatBounds();
            locations.forEach( ( loc ) => {
              if ( loc.lat && loc.lng ) bounds.extend( [loc.lng, loc.lat] );
            } );
            if ( !bounds.isEmpty() ) {
              map.fitBounds( bounds, {padding: 80, maxZoom: 14} );
              initialBounds = bounds;
            }
          }
        } );

        locations.forEach( ( loc ) => {
          if ( !loc.lat || !loc.lng ) return;
          const el = document.createElement( 'div' );
          el.className = 'map-marker';
          el.dataset.locationId = loc.id;
          el.style.transition = 'transform 0.2s ease';
          el.setAttribute( 'role', 'button' );
          el.setAttribute( 'tabindex', '0' );
          el.setAttribute( 'aria-label', `View ${loc.name} location on map` );
          el.setAttribute( 'aria-pressed', 'false' );

          const activate = () => setActive( loc.id );
          el.addEventListener( 'click', activate );
          el.addEventListener( 'keydown', ( e ) => {
            if ( e.key === 'Enter' || e.key === ' ' ) {
              e.preventDefault();
              activate();
            }
          } );

          const marker = new mapboxgl.Marker( el )
              .setLngLat( [loc.lng, loc.lat] )
              .addTo( map );

          markersById[loc.id] = marker;
        } );

        locationEls.forEach( ( el ) => {
          el.addEventListener( 'click', () => setActive( el.dataset.locationId ) );
          el.addEventListener( 'keydown', ( e ) => {
            if ( e.key === 'Enter' || e.key === ' ' ) {
              e.preventDefault();
              setActive( el.dataset.locationId );
            }
          } );
        } );

        const resetBtn = document.createElement( 'button' );
        resetBtn.textContent = 'Reset Map';
        resetBtn.className = 'absolute z-10 map-reset top-2 right-2 rounded-focus focus-visible:focus-styles';
        resetBtn.setAttribute( 'aria-label', 'Reset map to show all locations' );
        mapEl.appendChild( resetBtn );

        resetBtn.addEventListener( 'click', () => {
          if ( initialBounds ) {
            map.fitBounds( initialBounds, {padding: 80, maxZoom: 14} );
            clearActive();
          }
        } );
      } );
    },
    finalize() {},
  };

  app.registerComponent( 'location-map', COMPONENT );
} )( app );
